import React from "react";

import { Card, Col, Form, Popconfirm, Row, Select, Tooltip } from "antd";
import { SendOutlined, AddOutlined, ArchiveOutlined } from "@mui/icons-material";
import IconButton from "@Totum/Main/Components/shared/IconButton";

import useHeaderPresenter from "@Totum/QuestionnaireBuilder/Presentation//hooks/useHeaderPresenter";

const Header = () => {
    const { handlers, uiModel } = useHeaderPresenter();

    return (
        <header className={"questionnaires"}>
            <Card className="newUI-raised">
                <Row gutter={[8, 16]}>
                    <Col lg={14} md={12} xs={12}>
                        {uiModel.canShowSelect ? (
                            <Select
                                allowClear
                                className="full-width"
                                disabled={uiModel.isFetchingQuestionnaires}
                                fieldNames={{ label: "title", value: "questionnaireId" }}
                                loading={uiModel.isFetchingQuestionnaires}
                                onClear={handlers.handleQuestionnaireClear}
                                onSelect={handlers.handleQuestionnaireSelect}
                                options={uiModel.optionsForSelect}
                                placeholder={uiModel.selectFieldPlaceholder}
                                value={uiModel.questionnaire.questionnaireId}
                            />
                        ) : null}
                    </Col>
                    <Col lg={10} md={12} xs={12}>
                        <Form.Item style={{ margin: 0 }}>
                            <Row style={{ gap: "8px" }} justify="end">
                                <IconButton
                                    className="secondary flex"
                                    icon={<AddOutlined />}
                                    onClick={handlers.handleNewClick}
                                    style={{ gap: "5px" }}
                                >
                                    New
                                </IconButton>
                                {uiModel.questionnaire.isExistingQuestionnaire ? (
                                    <>
                                        <Popconfirm
                                            title={`Are you sure that you want to publish`}
                                            onConfirm={handlers.handlePublishClick}
                                        >
                                            <Tooltip placement="bottom" title={uiModel.tooltipMessage}>
                                                <div>
                                                    {/**
                                                     * ant d removes classes from disabled buttons nested in a
                                                     * tooltip so we are nesting the button in a div to prevent this
                                                     */}
                                                    <IconButton
                                                        className="dark flex"
                                                        disabled={!uiModel.canPublish}
                                                        icon={<SendOutlined />}
                                                        loading={uiModel.isPublishing}
                                                        style={{ gap: "5px" }}
                                                    >
                                                        {uiModel?.questionnaire?.isPublished ? "Published" : "Publish"}
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Popconfirm>
                                        <Popconfirm
                                            title={"Are you sure that you want to archive this Questionnaire?"}
                                            onConfirm={handlers.handleDelete}
                                            cancelButtonProps={{ className: "secondary" }}
                                        >
                                            <IconButton
                                                className="secondary danger flex"
                                                icon={<ArchiveOutlined />}
                                                style={{ gap: "5px" }}
                                            >
                                                Archive
                                            </IconButton>
                                        </Popconfirm>
                                    </>
                                ) : null}
                            </Row>
                        </Form.Item>
                    </Col>
                </Row>
            </Card>
        </header>
    );
};

export default Header;
